import React, { Suspense, useEffect, useState, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import retina from "retinajs";
import { AnimatePresence } from "framer-motion";
import GlobalContext from "./Context/Context";
import ScrollToTopButton from "./Components/ScrollToTop"

import "./Assets/css/climsedis.css"

// Pages
const LandingPage = lazy(() => import("./Pages/Landing"))
const ForecastingTool = lazy(() => import("./Pages/ForecastingTool"))
const Forecaster = lazy(() => import("./Pages/Forecaster"))
const FAQPage = lazy(() => import("./Pages/FAQ"))

function App() {
  const [headerHeight, setHeaderHeight] = useState(0);
  const [footerHeight, setFooterHeight] = useState(0);

  // RetinaJS
  useEffect(() => {
    window.addEventListener('load', retina(document.querySelectorAll('img')));
  }, [])


  return (
    <GlobalContext.Provider
      value={{
        headerHeight,
        setHeaderHeight,
        footerHeight,
        setFooterHeight,
      }}
    >
      <div className="App" style={{ "--header-height": `${headerHeight}px` }}>
        {
          <main style={{ marginTop: headerHeight, marginBottom: footerHeight }}>
            <ScrollToTopButton />
            <AnimatePresence mode='wait'>
              <Suspense fallback={<></>}>
                <Routes>
                  <Route path="/" element={<LandingPage style={{ "--base-color": "#e6994e" }} />} />
                  <Route path="/dashboard" element={<ForecastingTool style={{ "--base-color": "#e6994e" }} />} />
                  <Route path="/forecaster" element={<Forecaster style={{ "--base-color": "#e6994e" }} />} />
                  <Route path="/faq" element={<FAQPage style={{ "color": "#000000" }} />} />

                </Routes>

              </Suspense>
            </AnimatePresence>
          </main>
        }
      </div>
    </GlobalContext.Provider>
  )
}

export default App;